module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_06.b6832791.jpg";